/**
 * Email Lookup for Case-Insensitive Login
 *
 * Calls the email-lookup Lambda to get the correct email casing
 * before attempting to sign in with Cognito.
 */

import { EMAIL_LOOKUP_URL } from '../../utils/constants';

/**
 * Lookup the correct email casing from Cognito
 * Always returns an email (correct case if found, original if not)
 *
 * @param {string} email - Email entered by user
 * @returns {Promise<string>} - The correct email casing or original
 */
export async function lookupCorrectEmail(email) {
  if (!email) {
    return email;
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    const response = await fetch(EMAIL_LOOKUP_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (response.ok) {
      const data = await response.json();
      if (data.email) {
        return data.email;
      }
    }
  } catch (error) {
    console.warn('[EmailLookup] Failed, using original email:', error.message);
  }

  return email;
}
